/** Leads to Get access page */
export enum GetAccessLink {
  EN = 'https://bkbn.com/en/lets-talk',
  DE = 'https://bkbn.com/de/erhalten-sie-zugriff',
  FR = 'https://bkbn.com/fr/acces',
  ES = 'https://bkbn.com/es/obten-acceso',
  NL = 'https://bkbn.com/nl/krijg-toegang',
}
